/* src/components/Showcase/Showcase.jsx */
import './Showcase.css'
import {usePanelStatus} from "../HorizontalScroll/panelStatus.js";

// статус панелі з контексту → клас-фаза інтро
const STATUS_CLASS = {
	after: 'is-armed',   // ще не дійшли: стартові позиції, сховано
	active: 'is-in',     // доведена: зображення зліва + текст зверху (разом)
	before: 'is-out',    // пройшли далі: роз'їжджається назад
	static: null,        // без горизонтального скролу: просто показуємо контент
};

const Showcase = () => {
	const status = usePanelStatus();
	const classes = ['showcase', STATUS_CLASS[status]].filter(Boolean).join(' ');

	return (
		<section className={classes} id="about">
			<div className="showcase__content">
				<img
					className="showcase__image"
					src="/images/showcase.webp"
					alt="Showcase"
				/>

				<div className="showcase__text">
					<h2 className='showcase__title'>Avenue — це бруківка і ландшафтний декор, за якими стоїть "Ковальська"</h2>
					<span className='showcase__subtitle'>Власні родовища, німецьке обладнання Hess Group та інноваційний центр, який тримає планку якості. Усе для того, щоб місця, які ви створюєте, виглядали так само добре і через багато років</span>
				</div>
			</div>
		</section>
	);
};

export default Showcase;